import React, { Component } from 'react';
import Swiper from 'swiper';

export default class ArticleGrid extends Component {
  componentDidMount() {
    new Swiper('.ArticleGrid', {
      speed: 400,
      // spaceBetween: 35,
      slidesPerView: 'auto',
      preloadImages: false,
      lazy: true,
      watchSlidesVisibility: true,
      allowTouchMove: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      on: {
        init: function() {
          if (window.innerWidth >= 1024) {
            this.allowTouchMove = false;
          } else {
            this.allowTouchMove = true;
            this.slideTo(0);
          }
        },
        resize: function() {
          if (window.innerWidth <= 1024) {
            this.allowTouchMove = true;
            this.slideTo(0);
          } else {
            this.allowTouchMove = false;
          }
        }
      }
    });
  }
  render() {
    return (
      <div className={this.props.className}>
        <div className="swiper-wrapper">{this.props.children}</div>
        {this.props.pagination && (
          <div className="swiper-button-container">
            <div className="swiper-button-prev">
              <span />
              <span />
              <span />
            </div>
            <div className="swiper-button-next">
              <span />
              <span />
              <span />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ArticleGrid/ArticleGrid.jsx